"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FabricMapHost = void 0;
const react_1 = __importStar(require("react"));
const Context_1 = require("./Context");
const util_1 = require("../util");
exports.FabricMapHost = react_1.default.memo((props) => {
    /**
     * setProviderElement function reference changes every time, so we
     * use the ref instead. This lets our useEffect be less noisy.
     */
    const setProviderElement = (0, react_1.useContext)(Context_1.FabricMapPortalContext);
    const setProviderElementRef = react_1.default.useRef(setProviderElement);
    (0, util_1.useWhy)("FabricMapHost", Object.assign(Object.assign({}, props), { setProviderElement }));
    if (!setProviderElement) {
        throw new Error("FabricMapProvider not found in the parent hierarchy");
    }
    /**
     * Ensure that setProviderElementRef.current is the prop passed in.
     * useMemo fires before rendering
     */
    react_1.default.useMemo(() => {
        if (!setProviderElement) {
            throw new Error("FabricMapProvider not found in the parent hierarchy");
        }
        setProviderElementRef.current = setProviderElement;
    }, [setProviderElement]);
    /**
     * using the ref means we only react to props changes
     */
    react_1.default.useEffect(() => {
        setProviderElementRef.current(props);
    }, [props]);
    react_1.default.useEffect(() => () => setProviderElementRef.current(), []);
    return react_1.default.createElement(react_1.default.Fragment, null);
});
exports.FabricMapHost.displayName = "FabricMapHost";
